<template>
  <div class="dean-pagination" v-if="lastPage > 0">
    <div class="dean-pagination-container" v-if="lastPage > 1">
      <ul>
        <li @click.prevent="pageChanged(1)">
          <a href="#" aria-label="Eerste pagina">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>
        <li @click.prevent="pageChanged(currentPage - 1)">
          <a href="#" aria-label="Pagina terug">
            <span aria-hidden="true">&lsaquo;</span>
          </a>
        </li>
        <li
          v-for="n in paginationRange"
          :class="activePage(n)"
          @click.prevent="pageChanged(n)"
          :key="String(n)"
        >
          <a href="#">{{ n }}</a>
        </li>
        <li @click.prevent="pageChanged(currentPage + 1)">
          <a href="#" aria-label="Pagina verder">
            <span aria-hidden="true">&rsaquo;</span>
          </a>
        </li>
        <li @click.prevent="pageChanged(lastPage)">
          <a href="#" aria-label="Laatste pagina">
            <span aria-hidden="true">&raquo;</span>
          </a>
        </li>
      </ul>
    </div>
    <dean-input-select
      v-if="showItemsPerPage"
      class="items-per-page"
      :title="selectItemsPerPage.title"
      :options="selectItemsPerPage.items"
      :selected-item="String(itemsPerPage)"
      @selected-value="itemsPerPageChanged"
      :small="true"
      :number="true"
      :label="true"
    >
    </dean-input-select>
  </div>
</template>

<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import deanInputSelect from './deanInputSelect.vue';

// COMPONENTS
@Component({
  components: {
    deanInputSelect
  }
})
export default class deanPagination extends Vue {
  //PROPS
  @Prop({
    default: () => {
      return {
        title: 'Aantal rijen',
        items: [
          '5',
          '10',
          '15',
          '20',
          '25',
          '30',
          '40',
          '50',
          '100',
          '250',
          '500',
          '1000'
        ]
      };
    }
  })
  selectItemsPerPage!: object;
  @Prop() totalPages!: number;
  @Prop() itemsPerPage!: number;
  @Prop() totalItems!: number;
  @Prop({ required: true }) currentPage!: number;
  @Prop({ default: 5 }) visiblePages!: number;
  @Prop({ default: true }) showItemsPerPage!: boolean;

  // COMPUTED
  get lastPage() {
    if (this.totalPages) {
      return this.totalPages;
    } else {
      return this.totalItems % this.itemsPerPage === 0
        ? this.totalItems / this.itemsPerPage
        : Math.floor(this.totalItems / this.itemsPerPage) + 1;
    }
  }

  get paginationRange() {
    var num = this.lastPage - this.visiblePages + 1;
    var limit = 1;
    let start =
      this.currentPage - this.visiblePages / 2 <= 0
        ? 1
        : this.currentPage + this.visiblePages / 2 > this.lastPage
        ? //? Util.lowerBound(this.lastPage - this.visiblePages + 1, 1)
          //lowerBound
          num >= limit
          ? num
          : limit
        : Math.ceil(this.currentPage - this.visiblePages / 2);
    let range = [];
    for (let i = 0; i < this.visiblePages && i < this.lastPage; i++) {
      range.push(start + i);
    }
    return range;
  }

  //METHODS
  pageChanged(pageNum: number) {
    // window.scrollTo(0, 0);
    if (pageNum > this.lastPage) {
      this.$emit('page-changed', 1);
    } else if (pageNum < 1) {
      this.$emit('page-changed', this.lastPage);
    } else if (pageNum == this.currentPage) {
      console.log('pagination = curentpage');
    } else {
      this.$emit('page-changed', pageNum);
    }
  }

  itemsPerPageChanged(value: { [key: string]: string }) {
    console.log(value);
    let itemsPerPage = Number(value.selected);
    if (itemsPerPage != this.itemsPerPage) {
      console.log(itemsPerPage);
      this.$emit('items-per-page', itemsPerPage);
    }
  }

  activePage(pageNum: number) {
    return this.currentPage === pageNum ? 'active' : '';
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN PAGINATION
.dean-pagination {
  padding: 10px;
  @include display-flex();
  justify-content: flex-end;
  @media #{$small-only} {
    justify-content: center;
  }

  .dean-pagination-container {
    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: flex;
        font-weight: 500;
        width: 30px;
        height: 30px;
        text-align: center;
        align-items: center;
        justify-content: center;
        margin-left: 5px;
        border: 1px solid var(--color-light-shade-2, $color-light-shade-2);
        cursor: pointer;
        @include border-radius(200px);
        @include transition(0.5s);
        &:hover {
          background: var(--color-light, $color-light);
        }
        a {
          display: inline-flex;
          text-decoration: none;
          color: var(--color-dark-shade-2, $color-dark-shade-2);
          outline: 0;
        }
      }
      .active {
        &:hover {
          background: var(--color-link-shade-2, $color-link-shade-2);
          border: 1px solid var(--color-link-shade-2, $color-link-shade-2);
        }
        background: var(--color-link, $color-link);
        border: 1px solid var(--color-link, $color-link);
        @include border-radius(200px);

        a {
          color: white;
        }
      }
    }
  }
  .items-per-page {
    padding-left: 10px;
  }
  @media #{$small-only} {
    .items-per-page {
      display: none;
    }
  }
}
</style>
